import React from "react";

/**
 * Renders a heading line + its mirrored reflection below.
 * Pass `as` (h1/h2/h3) and standard className for the visible heading; reflection
 * inherits the styling automatically.
 */
const ReflectedHeading = ({
  as: Tag = "h2",
  className = "",
  children,
  reflectionScale = 0.55,
  testId,
  style,
}) => {
  return (
    <div className="relative" data-testid={testId}>
      <Tag className={`relative z-10 ${className}`} style={style}>{children}</Tag>
      <div
        aria-hidden="true"
        className={`reflection-text ${className}`}
        style={{ "--reflection-opacity": reflectionScale, ...(style || {}) }}
      >
        {children}
      </div>
    </div>
  );
};

export default ReflectedHeading;
